import { useMemo } from 'react';
import { useAutocompleteOptions } from 'utils/hooks/useAutocompleteOptions';
import { searchAssignmentTargets } from '../../assignedLabelsApi';
import type { LabelAssignmentTargetSearchResult } from '../../assignedLabelsTypes';
import {
  isTargetSearchReady,
  parseTargetSearchInput,
} from '../../parseTargetSearchInput';

const SEARCH_LIMIT = 50;

export const useLabelAssignmentTargetSearch = () => {
  const search = useAutocompleteOptions<LabelAssignmentTargetSearchResult>({
    debounceInterval: 300,
    load: async (input) => {
      const parsedInput = parseTargetSearchInput(input);
      if (!isTargetSearchReady(parsedInput)) {
        return { data: [], count: 0 };
      }

      const searchTerm =
        parsedInput.deviceSearch || parsedInput.interfaceFilter;
      const data = await searchAssignmentTargets(searchTerm, SEARCH_LIMIT);
      return { data, count: data.length };
    },
  });

  const parsedInput = useMemo(
    () => parseTargetSearchInput(search.inputValue),
    [search.inputValue],
  );

  return {
    inputValue: search.inputValue,
    setInputValue: search.handleInputValueChange,
    parsedInput,
    results: search.loadedData,
    isLoading: search.loadingData,
  };
};
